(function () {
  // CONFIG: edit if your color option has a different name
  var COLOR_OPTION_NAMES = ["Color", "Colour", "Shade"];

  function isColorOption(name) {
    if (!name) return false;
    var n = String(name).trim().toLowerCase();
    return COLOR_OPTION_NAMES.some(x => x.toLowerCase() === n);
  }

  // Try to find the "card" wrapper for a product link
  function findCard(el) {
    if (!el) return null;
    // climb max 6 levels
    var steps = 0, cur = el;
    while (cur && steps < 6) {
      if (cur.matches && (
        cur.matches('li, article, .grid__item, .card, .product-card, .product-item, .product-grid-item')
      )) return cur;
      cur = cur.parentElement; steps++;
    }
    return el.closest('li, article, .grid__item, .card, .product-card, .product-item, .product-grid-item');
  }

  // Find main image inside a card
  function findCardImage(card) {
    if (!card) return null;
    // common patterns across many themes
    return card.querySelector('img[loading], img[src], .media img, .card__media img, .product-card__media img, .product-item__image img, .media--hover img') || null;
  }

  // Find a place under title/price to insert
  function findInfoArea(card) {
    if (!card) return null;
    return card.querySelector('.card__information, .product-card__info, .card__content, .product-item__info, .card__inner, .card-information, .grid-view-item__info') || card;
  }

  // Build a swatch button
  function buildSwatch(value, variantId, imgUrl) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'swatch';
    btn.setAttribute('aria-label', value);
    btn.title = value;
    btn.dataset.variantId = variantId;
    btn.dataset.image = imgUrl || '';
    // Try use a CSS color; otherwise leave as is (you can add swatch images later)
    btn.style.backgroundColor = value;
    // Optional: if you upload assets like swatch-navy.png, uncomment and adjust path:
    // btn.style.backgroundImage = 'url(' + Shopify.assetUrl.replace(/\/[^\/]+$/, '/swatch-' + value.toLowerCase().replace(/\s+/g,'-') + '.png') + ')';
    return btn;
  }

  // Update link(s) and image for selected variant
  function applyVariantToCard(card, variantId, imageUrl) {
    // Update product links in the card
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var url = new URL(a.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', variantId);
        a.setAttribute('href', url.pathname + url.search);
      } catch (e) {}
    });
    // Swap image
    var img = findCardImage(card);
    if (img && imageUrl) {
      img.src = imageUrl;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
  }

  // Deduplicate first variant per color
  function firstVariantPerColor(product) {
    var colorIndex = -1;
    for (var i = 0; i < product.options.length; i++) {
      if (isColorOption(product.options[i])) { colorIndex = i; break; }
    }
    if (colorIndex === -1) return [];

    var seen = new Set();
    var out = [];
    product.variants.forEach(function (v) {
      var color = (v.options && v.options[colorIndex]) ? String(v.options[colorIndex]).trim() : '';
      if (!color) return;
      var key = color.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      out.push({
        value: color,
        id: v.id,
        image: (v.featured_image && v.featured_image.src) ? v.featured_image.src : (product.featured_image || '')
      });
    });
    return out;
  }

  function createSwatches(product, card) {
    var list = firstVariantPerColor(product);
    if (!list.length) return;

    var info = findInfoArea(card);
    if (!info) return;

    // Avoid duplicating
    if (info.querySelector('.swatches')) return;

    var wrap = document.createElement('div');
    wrap.className = 'swatches';

    var MAX = 6;
    list.slice(0, MAX).forEach(function (s, idx) {
      var btn = buildSwatch(s.value, s.id, s.image);
      if (idx === 0) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        // toggle active
        wrap.querySelectorAll('.swatch.is-active').forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        applyVariantToCard(card, s.id, s.image);
      });
      wrap.appendChild(btn);
    });

    if (list.length > MAX) {
      var more = document.createElement('span');
      more.className = 'swatch-more';
      more.textContent = '+' + (list.length - MAX);
      wrap.appendChild(more);
    }

    // Insert after title/price if possible, otherwise at end of info
    var anchor = info.querySelector('.price, [class*="price"], h3, .card__heading, .product-card__title') || info.lastElementChild;
    if (anchor && anchor.nextSibling) {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      info.appendChild(wrap);
    }

    // Apply first swatch selection
    applyVariantToCard(card, list[0].id, list[0].image);
  }

  function handleCard(link) {
    var card = findCard(link);
    if (!card) return;
    // Extract handle from /products/<handle>
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^\/\?\#]+)/);
    if (!m) return;
    var handle = m[1];
    if (!handle) return;

    // Avoid refetching the same handle per page
    if (!window.__swatchCache) window.__swatchCache = {};
    if (window.__swatchCache[handle] === 'loading') return;
    if (window.__swatchCache[handle] && window.__swatchCache[handle].product) {
      createSwatches(window.__swatchCache[handle].product, card);
      return;
    }

    window.__swatchCache[handle] = 'loading';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        window.__swatchCache[handle] = { product: product };
        createSwatches(product, card);
      })
      .catch(function () {
        window.__swatchCache[handle] = { product: null };
      });
  }

  function init() {
    // Only run on collection-like pages with product links
    var links = Array.from(document.querySelectorAll('a[href*="/products/"]'));
    // Restrict to visible grid/cards to avoid menus
    links = links.filter(function (a) {
      var card = findCard(a);
      return !!card && card.offsetParent !== null;
    });
    // Process each card once
    var processed = new WeakSet();
    links.forEach(function (a) {
      var card = findCard(a);
      if (!card || processed.has(card)) return;
      processed.add(card);
      handleCard(a);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // If your theme lazy-loads products via infinite scroll, observe new nodes
  if (window.MutationObserver) {
    var obs = new MutationObserver(function () {
      // throttle
      clearTimeout(window.__swatchTick);
      window.__swatchTick = setTimeout(function () {
        // re-run for newly added cards
        var links = document.querySelectorAll('a[href*="/products/"]');
        links.forEach(handleCard);
      }, 200);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
